/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.demographic-item[_ngcontent-%COMP%]   .demographic-item-legend[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;padding-top:30px}.demographic-item[_ngcontent-%COMP%]   .demographic-item-legend[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block}.demographic-item[_ngcontent-%COMP%]   .demographic-item-chart[_ngcontent-%COMP%]{position:relative;margin:0 auto}"];
export { styles as styles };
